const colors = {
  primary: "#CC0605",
  primaryShaded: "#b3d226",
  secondary: "#005756",
  secondaryShaded: "#063a49",
  secondaryLight: "#cedbda",
  tertiary: "#91aec1",
  tertiaryShaded: "#360e41",
  quatiary: "#00D9C0",
  quatiaryShaded: "#00ae9a",

  category_1: "#91aec1",
  category_2: "#005756",
  category_3: "#E82042",
  category_4: "#CEA9FF",

  dark: "#3C3C3B",
  light: "#F6F6F6",
  white: "#ffffff",

  grey: "#a6a6a6", // oder #bcbcbc
  lightgrey: "#F1F1F2",
  darkgrey: "#444444",
};

export default colors;
